<template>
  <Styles>
    <section id="store_container">
      <fieldset class="fieldset">
        <legend>Validar</legend>
        <div class="details-concept">
          <div class="columns">
            <div class="column is-4">
              <CompanySelector v-model="company" v-validate="'required'" placeholder="Seleccione una empresa"
                name="company" />
            </div>
          </div>
        </div>

        <p>
          Valida si la configuración del sistema en la empresa se encuentra
          correctamente ajustada para utilizar el sincronizador.
        </p>
        <div class="sync-validator-options">
          <div class="sync-validator-item" v-for="option in checkList" :value="option.id" :key="option.id"
            :id="option.id">
            <div class="loader-content" v-if="option.checking">
              <Loader />
            </div>
            <div :class="
              `circle ${
                !option.checked ? '' : option.valid ? 'success' : 'error'
              }`
            " v-if="!option.checking">
              <i class="mdi mdi-help" v-if="!option.checked"></i>
              <i class="mdi mdi-check" v-if="option.checked && option.valid"></i>
              <i class="mdi mdi-close" v-if="option.checked && !option.valid"></i>
            </div>
            <label class="label">{{ option.label }}</label>
          </div>
        </div>
        <hr />
        <vs-button color="primary" type="filled" icon="check" :disabled="cheking" @click="checkValidation(true)">
          Iniciar validación automática
        </vs-button>
      </fieldset>
      <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    </section>
  </Styles>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import Styles from "./styles";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { configToast, TOAST_TYPES } from "../../../global/toast";
import { ROUTES } from "../../../global/api_routes";
import checkList from "./checkList.json";
import Loader from "../../../components/Shared/Loader.vue";
import CompanySelector from "../../../components/Shared/CompanySelector";

export default {
  name: "Concepts",
  components: { Treeselect, Styles, Loader, CompanySelector },
  data: () => ({
    cheking: false,
    checkList: checkList,
    company: null,
    isLoading: false,
    companies: [],
  }),
  mounted() {
    this.getCompanies();
  },
  watch: {
    company: function () {
      this.cleanForm();
    },
  },
  methods: {
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#subscription_container");
      return instance.open(message, type);
    },
    cleanForm() {
      this.cleanList();
    },
    cleanList() {
      this.checkList = this.checkList.map((item) => ({
        ...item,
        valid: false,
        checking: false,
        checked: false,
      }));
    },
    getCompanies() {
      this.isLoading = true;
      this.$http
        .get(ROUTES.DASHBOARD.GET_COMPANIES_TREE)
        .then(({ data }) => {
          if (data.code > 0) {
            this.companies = data.info;
            this.processData(this.companies);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    processData(companies) {
      for (let index = 0; index < companies.length; index++) {
        let companie = companies[index];
        companie.label = companie.name;
        companie.id = companie.code;
        if (companie.children) {
          this.processData(companie.children);
        }
      }
    },
    changeValidationStatus(flag) {
      const list = this.checkList.map((item) => ({ ...item, checking: flag }));
      this.cheking = flag;
      this.checkList = list;
    },
    setCheckedList(flag) {
      const list = this.checkList.map((item) => ({
        ...item,
        checked: flag,
      }));
      return list;
    },
    fillResultCheck(data) {
      const list = this.setCheckedList(true);
      list[0].valid = data.existsGeneric;
      list[1].valid = data.existsDeviceEntry;
      list[2].valid = data.existsDeviceOut;
      list[3].valid = data.existsPrincipalSlot;
      list[4].valid = data.existsPrincipalPos;
      list[5].valid = data.existsConceptIva;
      list[6].valid = data.existsConceptParking;
      list[7].valid = data.existsConceptDiscount;
      list[8].valid = data.existsConceptAdjustment;
      list[9].valid = data.existsConceptAdjustmentTax;
      list[10].valid = data.existsConceptSubtotal;
      list[11].valid = data.existsConceptSubtotalTax;
      list[12].valid = data.existsConceptMonthly;
      list[13].valid = data.existsLiquidationSync;
      this.checkList = list;
    },
    async checkValidation() {
      const result = await this.$validator.validateAll();
      if (!result) {
        return;
      }
      this.changeValidationStatus(true);
      this.$http
        .get(ROUTES.DASHBOARD.SYNC.CHECK, {
          params: {
            companyId: this.company,
          },
        })
        .then(({ data }) => {
          if (data.code > 0) {
            this.cheking = true;
            this.fillResultCheck(data.info);
            return;
          }
          this.toast(data.message, TOAST_TYPES.ERROR);
        })
        .catch(() => {
          this.toast("Error al validar", TOAST_TYPES.ERROR);
          this.changeValidationStatus(false);
        })
        .finally(() => {
          this.changeValidationStatus(false);
        });
    },
  },
};
</script>
